var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5798 10.989L11.7844 10.1937L13.3751 8.6018C14.6936 7.28442 14.8714 5.3258 13.7734 4.22667C12.6743 3.12867 10.7156 3.30642 9.39714 4.62492L7.80752 6.21567L7.01214 5.4203L8.60289 3.82955C10.3613 2.0723 13.032 1.89455 14.5699 3.4313C16.1078 4.96917 15.9289 7.63992 14.1716 9.3983L12.5809 10.989H12.5798ZM10.989 12.5798L9.39827 14.1705C7.63989 15.9278 4.96914 16.1055 3.43127 14.5688C1.89339 13.0309 2.07227 10.3602 3.82952 8.6018L5.42027 7.01105L6.21564 7.80642L4.62489 9.3983C3.30639 10.7157 3.12864 12.6743 4.22664 13.7734C5.32577 14.8714 7.28439 14.6937 8.60289 13.3752L10.1936 11.7844L10.989 12.5798ZM10.989 6.21567L11.7844 7.01105L7.01101 11.7844L6.21564 10.989L10.989 6.21567Z",
    fill: "#2858B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpLink);
export default __webpack_public_path__ + "static/media/ep_link.ac24e1c639ab2b1a73ddca84b0b2f43b.svg";
export { ForwardRef as ReactComponent };